var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import getMessage from 'src/background/utils/i18n.utils';
import { DefaultAccountHistoryApis, DefaultSteemEngineRpcs, } from '@interfaces/steem-engine-rpc.interface';
import { setErrorMessage, setSuccessMessage, } from '@popup/multichain/actions/message.actions';
import { setTitleContainerProperties } from '@popup/multichain/actions/title-container.actions';
import { setActiveRpc } from '@popup/steem/actions/active-rpc.actions';
import { setHEActiveAccountHistoryApi, setHEActiveRpc, } from '@popup/steem/actions/steem-engine-config.actions';
import RpcUtils from '@popup/steem/utils/rpc.utils';
import { SteemEngineConfigUtils } from '@popup/steem/utils/steemengine-config.utils';
import { LocalStorageKeyEnum } from '@reference-data/local-storage-key.enum';
import { Screen } from '@reference-data/screen.enum';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { CheckboxPanelComponent } from 'src/common-ui/checkbox/checkbox-panel/checkbox-panel.component';
import CheckboxComponent from 'src/common-ui/checkbox/checkbox/checkbox.component';
import { ComplexeCustomSelect, } from 'src/common-ui/custom-select/custom-select.component';
import { SVGIcons } from 'src/common-ui/icons.enum';
import { InputType } from 'src/common-ui/input/input-type.enum';
import InputComponent from 'src/common-ui/input/input.component';
import { Separator } from 'src/common-ui/separator/separator.component';
import { SVGIcon } from 'src/common-ui/svg-icon/svg-icon.component';
import ArrayUtils from 'src/utils/array.utils';
import LocalStorageUtils from 'src/utils/localStorage.utils';
import * as ValidUrl from 'valid-url';
const RpcNodes = ({ activeRpc, activeAccountHistoryApi, activeHERpc, setActiveRpc, setHEActiveAccountHistoryApi, setHEActiveRpc, setErrorMessage, setSuccessMessage, setTitleContainerProperties, }) => {
    const allRpc = RpcUtils.getFullList();
    let displayedRpcs = allRpc;
    // Steem RPC
    const [customRpcs, setCustomRpcs] = useState([]);
    const [isAddRpcPanelDisplayed, setIsAddRpcPanelDisplayed] = useState(false);
    const [switchAuto, setSwitchAuto] = useState(true);
    const [addRpcNodeUri, setAddRpcNodeUri] = useState('');
    const [addRpcNodeChainId, setAddRpcNodeChainId] = useState('');
    const [addRpcNodeTestnet, setAddRpcNodeTestnet] = useState(false);
    const [setNewRpcAsActive, setSetNewRpcAsActive] = useState(false);
    const [steemRpcOptions, setSteemRpcOptions] = useState(allRpc.map((rpc) => {
        return {
            label: rpc.uri,
            value: rpc.uri,
            rpc: rpc,
            canDelete: RpcUtils.isDefault(rpc),
        };
    }));
    // Steem Engine RPC
    const [steemEngineRpcOptions, setSteemEngineRpcOptions] = useState([]);
    const [newHERpc, setNewHERpc] = useState('');
    const [isNewHERpcPanelOpened, setIsNewHERpcPanelOpened] = useState(false);
    const [setNewHeRpcAsActive, setSetNewHeRpcAsActive] = useState(false);
    const deleteHeRpc = (option, event) => __awaiter(void 0, void 0, void 0, function* () {
        event.preventDefault();
        event.stopPropagation();
        yield SteemEngineConfigUtils.deleteCustomRpc(option.value);
        initLayer2();
    });
    // Steem Engine account history
    const [accountHistoryApiOptions, setAccountHistoryApiOptions] = useState([]);
    const [isNewAccountHistoryPanelOpened, setIsNewAccountHistoryPanelOpened] = useState(false);
    const [newAccountHistory, setNewAccountHistory] = useState('');
    const [setNewAccountHistoryAsActive, setSetNewAccountHistoryAsActive] = useState(false);
    const deleteAccountHistoryApi = (option, event) => __awaiter(void 0, void 0, void 0, function* () {
        event.preventDefault();
        event.stopPropagation();
        yield SteemEngineConfigUtils.deleteCustomAccountHistoryApi(option.value);
        initLayer2();
    });
    useEffect(() => {
        initLayer2();
    }, []);
    const initLayer2 = () => __awaiter(void 0, void 0, void 0, function* () {
        const customRpcs = yield SteemEngineConfigUtils.getCustomRpcs();
        const rpcFullList = ArrayUtils.mergeWithoutDuplicate(customRpcs, DefaultSteemEngineRpcs);
        const rpcOpts = rpcFullList.map((rpc) => {
            return {
                panelType: 'rpc',
                label: rpc.replace('http://', '').replace('https://', '').split('/')[0],
                value: rpc,
                canDelete: !SteemEngineConfigUtils.isRpcDefault(rpc),
            };
        });
        setSteemEngineRpcOptions(rpcOpts);
        const customAccountHistoryApi = yield SteemEngineConfigUtils.getCustomAccountHistoryApi();
        const accountHistoryApiFullList = ArrayUtils.mergeWithoutDuplicate(customAccountHistoryApi, DefaultAccountHistoryApis);
        const accountHistoryApiOpts = accountHistoryApiFullList.map((api) => {
            return {
                panelType: 'account-history-api',
                label: api.replace('http://', '').replace('https://', '').split('/')[0],
                value: api,
                canDelete: !SteemEngineConfigUtils.isAccountHistoryApiDefault(api),
            };
        });
        setAccountHistoryApiOptions(accountHistoryApiOpts);
    });
    useEffect(() => {
        displayedRpcs = [...allRpc, ...customRpcs];
        setSteemRpcOptions(displayedRpcs.map((rpc) => {
            return {
                label: rpc.uri,
                value: rpc.uri,
                rpc: rpc,
                canDelete: !RpcUtils.isDefault(rpc),
            };
        }));
    }, [customRpcs]);
    useEffect(() => {
        setTitleContainerProperties({
            title: 'popup_html_rpc_node',
            isBackButtonEnabled: true,
        });
        initCustomRpcList();
        initSwitchAuto();
    }, []);
    useEffect(() => {
        const saveSwitchAuto = () => __awaiter(void 0, void 0, void 0, function* () {
            yield LocalStorageUtils.saveValueInLocalStorage(LocalStorageKeyEnum.SWITCH_RPC_AUTO, switchAuto);
        });
        saveSwitchAuto();
    }, [switchAuto]);
    const initSwitchAuto = () => __awaiter(void 0, void 0, void 0, function* () {
        setSwitchAuto(yield LocalStorageUtils.getValueFromLocalStorage(LocalStorageKeyEnum.SWITCH_RPC_AUTO));
    });
    const initCustomRpcList = () => __awaiter(void 0, void 0, void 0, function* () {
        setCustomRpcs(yield RpcUtils.getCustomRpcs());
    });
    const deleteCustomSteemRPC = (item, event) => __awaiter(void 0, void 0, void 0, function* () {
        event.preventDefault();
        event.stopPropagation();
        const newRpcs = RpcUtils.deleteCustomRpc(customRpcs, item.rpc);
        setCustomRpcs(newRpcs);
        initCustomRpcList();
    });
    const saveNewSteemRpc = () => {
        if (!addRpcNodeUri.length ||
            (addRpcNodeTestnet && !addRpcNodeChainId.length)) {
            setErrorMessage('popup_html_rpc_missing_fields');
            return;
        }
        if (!ValidUrl.isWebUri(addRpcNodeUri)) {
            setErrorMessage('html_popup_url_not_valid');
            return;
        }
        if (displayedRpcs.find((rpc) => rpc.uri === addRpcNodeUri)) {
            setErrorMessage('popup_html_rpc_uri_already_existing');
            return;
        }
        const newCustomRpc = {
            uri: addRpcNodeUri,
            testnet: addRpcNodeTestnet,
            chainId: addRpcNodeChainId.length ? addRpcNodeChainId : undefined,
        };
        setIsAddRpcPanelDisplayed(false);
        RpcUtils.addCustomRpc(newCustomRpc);
        setCustomRpcs([...customRpcs, newCustomRpc]);
        if (setNewRpcAsActive) {
            setSwitchAuto(false);
            setActiveRpc(newCustomRpc);
        }
    };
    const saveAccountHistory = () => __awaiter(void 0, void 0, void 0, function* () {
        if (accountHistoryApiOptions.find((e) => e.value === newAccountHistory)) {
            setErrorMessage('html_popup_rpc_already_exist');
            return;
        }
        if (ValidUrl.isWebUri(newAccountHistory)) {
            yield SteemEngineConfigUtils.addCustomAccountHistoryApi(newAccountHistory);
            setNewAccountHistory('');
            setIsNewAccountHistoryPanelOpened(false);
            setSuccessMessage('html_popup_new_account_history_save_success');
            initLayer2();
        }
        else {
            setErrorMessage('html_popup_url_not_valid');
        }
    });
    const saveHiveEngineRpc = () => __awaiter(void 0, void 0, void 0, function* () {
        if (steemEngineRpcOptions.find((e) => e.value === newHERpc)) {
            setErrorMessage('html_popup_rpc_already_exist');
            return;
        }
        if (ValidUrl.isWebUri(newHERpc)) {
            setSuccessMessage('html_popup_new_rpc_save_success');
            yield SteemEngineConfigUtils.addCustomRpc(newHERpc);
            setNewHERpc('');
            setIsNewHERpcPanelOpened(false);
            initLayer2();
        }
        else {
            setErrorMessage('html_popup_url_not_valid');
        }
    });
    return (React.createElement("div", { "data-testid": `${Screen.SETTINGS_RPC_NODES}-page`, className: "rpc-nodes-page" },
        React.createElement("div", { className: "introduction" }, getMessage('popup_html_rpc_node_text')),
        React.createElement("div", { className: "rpc-form-container" },
            React.createElement("div", { className: "rpc-section hive-rpc" },
                React.createElement("div", { className: "title" }, "Steem RPC"),
                React.createElement(CheckboxPanelComponent, { dataTestId: "checkbox-rpc-nodes-automatic-mode", title: "popup_html_rpc_automatic_mode", hint: "popup_html_rpc_automatic_mode_hint", checked: switchAuto, onChange: setSwitchAuto }),
                activeRpc && !switchAuto && steemRpcOptions && (React.createElement("div", { className: "select-rpc-panel" },
                    React.createElement(ComplexeCustomSelect, { options: steemRpcOptions, selectedItem: {
                            value: activeRpc.uri,
                            label: activeRpc.uri
                                .replace('http://', '')
                                .replace('https://', '')
                                .split('/')[0],
                            rpc: activeRpc,
                            canDelete: !RpcUtils.isDefault(activeRpc),
                        }, setSelectedItem: (item) => setActiveRpc(item.rpc), background: "white", onDelete: deleteCustomSteemRPC }),
                    React.createElement("div", { className: `round-button ${isAddRpcPanelDisplayed ? 'close-button' : 'add-button'}`, onClick: () => setIsAddRpcPanelDisplayed(!isAddRpcPanelDisplayed) },
                        React.createElement(SVGIcon, { icon: SVGIcons.MENU_RPC_ADD_BUTTON })))),
                !switchAuto && isAddRpcPanelDisplayed && (React.createElement("div", { className: "add-rpc-panel" },
                    React.createElement("div", { className: "add-rpc-caption" },
                        React.createElement("span", null, getMessage('popup_html_add_rpc_text')),
                        React.createElement(SVGIcon, { icon: SVGIcons.MENU_RPC_SAVE_BUTTON, onClick: () => saveNewSteemRpc() })),
                    React.createElement(Separator, { type: "horizontal" }),
                    React.createElement(InputComponent, { dataTestId: "input-rpc-node-uri", type: InputType.TEXT, value: addRpcNodeUri, onChange: setAddRpcNodeUri, placeholder: 'popup_html_rpc_node', onEnterPress: saveNewSteemRpc }),
                    React.createElement(CheckboxComponent, { dataTestId: "checkbox-add-rpc-test-node", title: "Testnet", checked: addRpcNodeTestnet, onChange: setAddRpcNodeTestnet, skipTranslation: true }),
                    addRpcNodeTestnet && (React.createElement(InputComponent, { dataTestId: "input-node-chain-id", type: InputType.TEXT, value: addRpcNodeChainId, onChange: setAddRpcNodeChainId, placeholder: "Chain Id", skipPlaceholderTranslation: true, onEnterPress: saveNewSteemRpc })),
                    React.createElement(CheckboxComponent, { dataTestId: "checkbox-set-new-rpc-as-active", title: "popup_html_set_new_rpc_as_active", checked: setNewRpcAsActive, onChange: setSetNewRpcAsActive })))))));
};
const mapStateToProps = (state) => {
    return {
        activeRpc: state.steem.activeRpc,
        activeHERpc: state.steem.steemEngineConfig.rpc,
        activeAccountHistoryApi: state.steem.steemEngineConfig.accountHistoryApi,
    };
};
const connector = connect(mapStateToProps, {
    setActiveRpc,
    setHEActiveAccountHistoryApi,
    setHEActiveRpc,
    setErrorMessage,
    setTitleContainerProperties,
    setSuccessMessage,
});
export const RpcNodesComponent = connector(RpcNodes);
